import {clientIntl} from '../../../../../shared/scripts/ClientI18n'
import {ViewPopupLanguage} from '../../../../../shared/scripts/ui_popup/ViewPopupLanguage'
import {UIMMenuGameOrientationController} from './UIMMenuGameOrientationController'
import {UIUtilsEjsVariables} from '../../../../../shared/scripts/UIUtilsEjsVariables'
import {setElementInnerHTML} from '../../../../../shared/scripts/ui_utils/DomUtils'

enum MenuState {
    OPEN,
    CLOSED
}
export class UIMHeaderHamburgerController {
    private readonly hamburger: HTMLElement
    private readonly overlayScreen: HTMLElement
    private readonly menu: HTMLDivElement
    private readonly closeButton: HTMLElement
    private readonly changeLanguageButton: HTMLButtonElement

    private menuState: MenuState

    constructor() {
        this.menu = document.getElementById('m-mainpage-menu') as HTMLDivElement
        this.hamburger = document.getElementById('header-element-hamburger-container') as HTMLElement
        this.closeButton = document.getElementById('m-mainpage-menu-close') as HTMLElement
        this.overlayScreen = document.getElementById('m-mainpage-overlay') as HTMLElement
        this.changeLanguageButton = document.getElementById('m-mainpage-language-selector') as HTMLButtonElement
        new UIMMenuGameOrientationController()

        this.setOpenAndCloseAction()
    }

    private setOpenAndCloseAction() {
        this.hamburger.onclick = () => this.setOpenAction()
        this.closeButton.onclick = () => this.setCloseAction()
        this.overlayScreen.onclick = () => this.setCloseAction()

        const languageDisplayName = clientIntl.getLanguageName(UIUtilsEjsVariables.language) as string
        setElementInnerHTML(this.changeLanguageButton, {key: 'strings:colonistCommon.utils.#buffer', options: {value: languageDisplayName}})
        this.changeLanguageButton.onclick = () => {
            this.setCloseAction()
            new ViewPopupLanguage()
        }
    }

    private setOpenAction() {
        if(this.menuState == MenuState.OPEN) return
        this.menu.classList.add('open')
        this.overlayScreen.style.display = 'block'
        this.menuState = MenuState.OPEN
    }

    setCloseAction() {
        if(this.menuState == MenuState.CLOSED) return
        this.menu.classList.remove('open')
        this.overlayScreen.style.display = 'none'
        this.menuState = MenuState.CLOSED
    }

    hide() {
        this.menu.style.display = 'none'
    }

    show() {
        this.menu.style.display = ''
    }
}
